import { render, staticRenderFns } from "./WorkflowTypeSelection.view.vue?vue&type=template&id=18350330&scoped=true"
import script from "./WorkflowTypeSelection.view.vue?vue&type=script&lang=js"
export * from "./WorkflowTypeSelection.view.vue?vue&type=script&lang=js"
import style0 from "./WorkflowTypeSelection.view.vue?vue&type=style&index=0&id=18350330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18350330",
  null
  
)

export default component.exports